'use client';

import {trackTakeHomeDataDownloaded} from 'iq-takehomes/tracking';
import {FileDown} from 'lucide-react';

interface Props {
  href: string;
  slug: string;
}

export function DataDownloadLink({href, slug}: Props) {
  return (
    <a
      href={href}
      download
      onClick={() => { void trackTakeHomeDataDownloaded(slug); }}
      className='inline-flex items-center gap-2 mt-8 px-5 py-3 rounded-xl bg-iq-orange hover:bg-iq-orange-dark transition-colors text-sm font-semibold text-white'>
      <FileDown className='w-4 h-4' strokeWidth={1.5} />
      Download project files
    </a>
  );
}
